












































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';

@Component({
    computed: {
        ...mapGetters({
            currentIntegration: 'Integrations/getCurrentIntegration',
        }),
    },
})
export default class PreviewIntegration extends Vue {

    constructor() {
        super();
    }

    public downloadIntegrationFile(file: any, name: string, type: string) {
        if (type === 'xlsx' || type === 'xls') {
            saveAs('data:application/vnd.ms-excel;base64,' + file, name);
        } else {
            saveAs('data:text/csv;charset=utf-8;base64,' + file, name);
        }
    }

    public cancel() {
        this.$store.commit(Mutations.SET_PREVIEW_INTEGRATION_VISIBILITY, false);
    }
}
